import { IApplicationState } from '../../types/redux';

export function getDiscountMortgage(state: IApplicationState): boolean {
  return state.newbuilding.hasDiscountMortgage;
}
